import React, { useMemo } from 'react'

import { API_URL } from '../constants'

import { useItems } from '../../hooks'

import FormField, { FIELD_TYPES } from '../../components/FormField'

import styles from './PermissionsCheckList.module.css'

const PermissionsCheckList = ({
  field: { label, name, defaultValue },
  item,
  onChange,
  value,
}) => {
  const [{ response: permissions, isLoading, error }] = useItems(API_URL)

  const agencyFields = useMemo(() => {
    if (isLoading || error || !permissions) return null
    return {
      type: FIELD_TYPES.CHECKBOX_ARRAY,
      label: 'Agencies',
      name,
      defaultValue,
      options: permissions
        .filter((p) => p.typeId === 2)
        .map((p) => ({
          id: p.id,
          label: p.name,
        })),
    }
  }, [name, defaultValue, permissions, isLoading, error])

  const featureFields = useMemo(() => {
    if (isLoading || error || !permissions) return null
    return {
      type: FIELD_TYPES.CHECKBOX_ARRAY,
      label: 'Features',
      name,
      defaultValue,
      options: permissions
        .filter((p) => p.typeId === 1)
        .map((p) => ({
          id: p.id,
          label: p.name,
        })),
    }
  }, [name, defaultValue, permissions, isLoading, error])

  if (featureFields === null || agencyFields === null)
    return (
      <div>
        <label>{label}</label>
        <div>
          Loading Permissions... <i className="fa fa-spinner fa-spin"></i>
        </div>
      </div>
    )

  return (
    <>
      <h4>{label}</h4>
      <div className={styles.listContainer}>
        <FormField field={featureFields} item={item} onChange={onChange} />
        <FormField field={agencyFields} item={item} onChange={onChange} />
      </div>
    </>
  )
}

export default PermissionsCheckList
